module.exports = __webpack_public_path__ + "static/media/discover.8fc75652.png";